// src/features/mech/plastics/questions/PartNameQuestion.jsx
import React from "react";
import PerlTextField from "../../../../shared/components/PerlTextField";
import PerlLabelMedium from "../../../../shared/components/PerlLabelMedium";

/**
 * PartNameQuestion Component
 *
 * Custom question for Mechanical Plastics: captures the part name
 * Mirrors the legacy "Part Name" field from CostingConfigPlasticMolding
 *
 * @param {string} value - Current part name
 * @param {function} onChange - Callback when the part name changes
 * @param {string} [error] - Optional error message
 * @param {string} [success] - Optional success/help message
 * @param {function} [onNextStep] - Optional callback to proceed to next step on Enter key
 * @param {number} [currentStep] - Current step index
 */
export default function PartNameQuestion({ value, onChange, error, success, onNextStep, currentStep }) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && onNextStep && value && value.trim() !== "") {
      e.preventDefault();
      onNextStep();
    }
  };

  return (
    <>
      <PerlLabelMedium sx={{ mb: 2, display: "block" }}>Enter Part Name/Number:</PerlLabelMedium>
      <PerlTextField
        fullWidth
        placeholder="Enter part name"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        error={Boolean(error)}
        helperText={error}
      />
      {success && (
        <PerlLabelMedium sx={{ mt: 1, color: "success.main" }}>{success}</PerlLabelMedium>
      )}
    </>
  );
}

